import baustein from "baustein";
import browser from "web/script/utils/browser";
import _ from "underscore";

var DROPDOWN_TAB = ".category-menu-tabs__tab";
var DROPDOWN_TAB_OPEN_CLASS = "category-menu-tabs__tab--open";
var DROPDOWN_MENU = ".category-menu-dropdown";
var DROPDOWN_MENU_OPEN_CLASS = "category-menu-dropdown--open";

export default baustein.register("category-menu", {
    setupEvents: function(add) {
        add("click", DROPDOWN_TAB, this._onDropdownClick);
        add("mouseenter", DROPDOWN_TAB, this._onDropdownHover);
        add("mouseleave", DROPDOWN_TAB, this._onDropdownMouseLeave);
    },

    _onDropdownClick: function(event) {
        var clickedMenu = event.target;

        this._openDropdown(clickedMenu);
    },

    _onDropdownHover: function(event) {
        // We don't need hover handlers on mobile
        if (browser.getViewport() < browser.VIEWPORTS.DESKTOP) {
            return;
        }

        var clickedMenu = event.target;

        this._openDropdown(clickedMenu);
    },

    _onDropdownMouseLeave: function(event) {
        // We don't need hover handlers on mobile and
        // we need to return if there's no relatedTarget
        if (browser.getViewport() < browser.VIEWPORTS.DESKTOP || !event.relatedTarget) {
            return;
        }

        var mouseLeaveTarget = event.relatedTarget;

        var isHoveringMenu = this.el.contains(mouseLeaveTarget);
        var hoveredMenuIsDisabled = mouseLeaveTarget.classList.contains(
            "category-menu-tabs__tab--disabled"
        );
        var hoveredElIsContainer =
            mouseLeaveTarget.classList.contains("category-menu-tabs") ||
            mouseLeaveTarget.classList.contains("category-menu");

        if (isHoveringMenu && !hoveredMenuIsDisabled && !hoveredElIsContainer) {
            return;
        }

        this.closeAllDropdowns();
    },

    _openDropdown: function(clickedMenu) {
        var dropdown = clickedMenu.querySelector(DROPDOWN_MENU);

        // Clicking on an open menu should close it
        if (dropdown && dropdown.classList.contains(DROPDOWN_MENU_OPEN_CLASS)) {
            dropdown.classList.remove(DROPDOWN_MENU_OPEN_CLASS);
            clickedMenu.classList.remove(DROPDOWN_TAB_OPEN_CLASS);
        } else if (dropdown) {
            this.closeAllDropdowns();

            dropdown.classList.add(DROPDOWN_MENU_OPEN_CLASS);
            clickedMenu.classList.add(DROPDOWN_TAB_OPEN_CLASS);
        }
    },

    closeAllDropdowns: function() {
        var dropdownTabs = this.el.querySelectorAll(DROPDOWN_TAB);
        var dropdownMenus = this.el.querySelectorAll(DROPDOWN_MENU);

        _.each(dropdownTabs, function(el) {
            el.classList.remove(DROPDOWN_TAB_OPEN_CLASS);
        });

        _.each(dropdownMenus, function(el) {
            el.classList.remove(DROPDOWN_MENU_OPEN_CLASS);
        });
    },
});
